//dependencies
import { SpringConfig, useSpring } from "@react-spring/web";
import React, { useEffect, useRef } from "react";
import { useResizeObserver } from "usehooks-ts";

type useVerticalExpanderProps = {
	isExpanded: boolean;
	closedHeight?: number;
	openHeightOverride?: number;
	config?: SpringConfig;
	initialAnimate?: boolean;
	disableAnimation?: boolean;
};

const useVerticalExpander = ({
	isExpanded,
	closedHeight = 0,
	openHeightOverride,
	config = { tension: 280, friction: 30 },
	initialAnimate = false,
	disableAnimation = false,
}: useVerticalExpanderProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const { height = 0 } = useResizeObserver<HTMLDivElement>({
		ref,
	});
	const [movedFromZero, setMovedFromZero] = React.useState(false);

	// this is needed for when the component is initially rendered with a height of 0
	useEffect(() => {
		if (height > 0) {
			setMovedFromZero(true);
		} else {
			setMovedFromZero(false);
		}
	}, [height]);

	const openHeight = openHeightOverride ? openHeightOverride : height;

	const springs = useSpring({
		maxHeight: isExpanded ? openHeight : closedHeight,
		immediate: disableAnimation || (!initialAnimate && !movedFromZero),
		config,
	});

	// style is applied to the animated.div in the VerticalExpander component or the parent animated.div in implementation
	// ref is applied to the inner content of the expander
	// see VerticalExpander component for an example of implementation
	// Can most likely use Vertical expander component in most cases
	return { style: springs, ref };
};

export default useVerticalExpander;
